// extracted by css-extract-rspack-plugin
export default {"tablist":"tabs-module__tablist","tab":"tabs-module__tab","withoutBorder":"tabs-module__withoutBorder","active":"tabs-module__active","removeMargin":"tabs-module__removeMargin"};